import Link from 'next/link'
import { ButtonGroup } from 'react-bootstrap'
import { Designed } from 'web_core/types'

type Props = {
  link: string
  active: 'all' | 'recommend' | 'following'
}

export const FollowingNavSelector = ({
  link,
  active,
  ...wrapperProps
}: Designed<Props>) => {
  return (
    <ButtonGroup {...wrapperProps} size="sm">
      <Link href={link.replace('[prefix]', '')}>
        <a
          className={
            active === 'recommend'
              ? 'btn btn-sm btn-secondary'
              : 'btn btn-sm btn-outline-secondary'
          }
          style={{ width: 100 }}
        >
          おすすめ
        </a>
      </Link>
      <Link href={link.replace('[prefix]', 'following_')}>
        <a
          className={
            active === 'following'
              ? 'btn btn-sm btn-secondary'
              : 'btn btn-sm btn-outline-secondary'
          }
          style={{ width: 100 }}
        >
          フォロー中
        </a>
      </Link>
      <Link href={link.replace('[prefix]', 'all_')}>
        <a
          className={
            active === 'all'
              ? 'btn btn-sm btn-secondary'
              : 'btn btn-sm btn-outline-secondary'
          }
          style={{ width: 100 }}
        >
          すべて
        </a>
      </Link>
    </ButtonGroup>
  )
}
